import axios from "axios";
import config from "../config";

// Account types
export type Account = {
  id: string;
  email: string;
  created_at: string;
};

export type Accounts = {
  accounts: Account[];
};

export type CreateAccountInput = {
  id: string;
  email: string;
};

export type CreateAccountOutput = {
  id: string;
};

export type UpdateAccountInput = {
  email: string;
};

export type GetAccountOutput = {
  id: string;
  email: string;
};

// Account API functions
export const listAccounts = async (token: string): Promise<Accounts> => {
  const response = await axios.get<Accounts>(`${config.apiUrl}/accounts`, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
  return response.data;
};

export const createAccount = async (token: string, data: CreateAccountInput): Promise<CreateAccountOutput> => {
  const response = await axios.post<CreateAccountOutput>(`${config.apiUrl}/accounts`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
  return response.data;
};

export const updateAccount = async (token: string, accountId: string, data: UpdateAccountInput): Promise<void> => {
  await axios.put(`${config.apiUrl}/accounts/${accountId}`, data, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
};

export const getAccount = async (token: string, accountId: string): Promise<GetAccountOutput> => {
  const response = await axios.get<GetAccountOutput>(`${config.apiUrl}/accounts/${accountId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
  return response.data;
};
